import defaultSettings from '@/settings'

const title = defaultSettings.title || '体育健康云'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
